<template>

    <div>
        <!-- position center -->
        <b-modal ref="paymentMethodModal" hide-footer size="lg" centered title="Payment Method Details">
            <div class="row">
                <div class="col-md-12">
                    <StripePayment ref="stripePM" title="" />
                </div>
                <div class="col-md-12">
                    <div class="ms-1 mb-3 d-flex align-items-center">
                        <input type="checkbox" v-model="default_payment_method" id="defaultPaymentMethod" />
                        <label class="ms-2 mb-0" for="defaultPaymentMethod">
                            Make it Default <i class="fas fa-question-circle cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top" title="All upcoming charges will be processed with this payment method"></i>
                        </label> 
                    </div>
                </div>
                <div class="col-md-12 d-flex justify-content-end">
                    <SubmitButton type="button" :processing="processing" @clicked="savePaymentMethod" class="btn btn-primary"
                        defaultClass="btn border-0 px-5 fw-bold text-white w-25 rounded-pill f-12" text="Submit" />
                </div>
            </div>
        </b-modal>
    </div>

</template>


<script>
import StripePayment from "@/components/StripePaymentMethod";
import SubmitButton from "@/components/general/SubmitButton.vue";
export default {
    name: "PaymentMethodModal",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    components: {
        StripePayment,
        SubmitButton
    },
    data() {
        return {
            default_payment_method: false,
            payment_method_id:null,
            processing:false
        }
    },
    methods: {
        openModal() {
            this.$refs.paymentMethodModal.show();
        },
        closeModal() {
            this.default_payment_method = false;
            this.payment_method_id = null;
            this.processing = false;
            this.$refs.paymentMethodModal.hide();
        },
        async savePaymentMethod() {
            this.processing = true;
            var payment_method_id = await this.$refs.stripePM.getPaymentMethodId();
            this.payment_method_id = payment_method_id;
            if (!payment_method_id) {
                this.triggerSwal("Please Complete Payment Details", "error");
                this.processing = false;
                return;
            }  

            let payload = {
                user_id: this.user.id,
                payment_method_id: this.payment_method_id,
                is_default: this.default_payment_method
            }

            this.$axios
                .post("attach-payment-method", payload)
                .then((response) => {
                    this.triggerSwal(response.data.message, "success");
                    this.processing = false;
                    this.closeModal();
                    this.$emit('on-payment-created');
                })
                .catch((error) => {
                    this.handleErrorResponse(error.response, "error");
                    this.processing = false;
                });

        }
    }
}
</script>